import { AbstractDTO } from "@signature-it/ngx-generic/models";

export class CartTotalPriceDTO extends AbstractDTO {
    total_price_before_discount: number;
    total_price_after_discount: number;
    delivery_price: number;
    calculated_vat: number;
    session_currency: string;
    calculated_total_price: number;
    points_discount: number;
    delivery_discount: number;
    additional_data: string;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.total_price_before_discount = Number(attributes['total_price_before_discount']) || 0;
        this.total_price_after_discount = Number(attributes['total_price_after_discount']) || 0;
        this.delivery_price = Number(attributes['delivery_price']) || 0;
        this.calculated_vat = Number(attributes['calculated_vat']) || 0;
        this.points_discount = Number(attributes['points_discount']) || 0;
        // this.SessionCurrency = {}; // FIXME: SessionCurrencyDTO.createFromArray
        this.session_currency = attributes['session_currency'] || 'USD';
        this.delivery_discount = attributes['delivery_discount'] || 0;
        this.calculated_total_price = this.total_price_after_discount + this.delivery_price + this.calculated_vat - this.delivery_discount;
        this.additional_data = attributes['additional_data'] || null;

    }

}
